import { TiledGameObject } from "./phaserHelpers/HandyTypes";
import { PhaserButton, PhaserButtonConfig } from "./Button";
import { Color } from "./ColorValue";
import TranslateApi from "src/utils/TranslateHelper";

export class InstructionsTextBoxConfig {
    padding?: number = 20;
    fontSize: number;
    hollandCode: "r" | "i" | "a" | "s" | "e" | "c";
    translationKeys: string[];
    onBack: any;
    onStartGame: any;
    onKeyboardInstructions: any;
}

export class GameInstructionsTextBox extends Phaser.GameObjects.Container {
    config: InstructionsTextBoxConfig;

    obWidth: number;
    background: Phaser.GameObjects.Image;
    border: Phaser.GameObjects.Image;
    paragraphs: Phaser.GameObjects.Text[];
    backButton: PhaserButton;
    startGameButton: PhaserButton;

    constructor(scene: Phaser.Scene, ob: TiledGameObject, config: InstructionsTextBoxConfig) {
        super(scene, ob.x, ob.y, []);

        this.obWidth = ob.width;
        this.config = config;

        this.createBox();
        scene.add.existing(this);
    }

    createBox() {
        var borderWidth = 10;
        var borderColor = Color.PLANET_COLORS.get(this.config.hollandCode.toUpperCase());
        var verticalSpacing = this.config.padding;
        var paragraphSpacing = 5;
        this.paragraphs = [];
        var textStyle = { fontFamily: 'Roboto Mono, Arial', color: "#F8E71C", fontSize: this.config.fontSize, padding: 10 };

        // Add all the paragraphs to one big textbox
        this.config.translationKeys.forEach((key: string) => {
            var translatedText = TranslateApi.translate(key);
            // Split the translated text by newlines to create paragraphs
            translatedText.split("|").map(x => x.trim()).forEach((para: string) => {
                var paragraph = this.scene.add.text(this.config.padding, verticalSpacing, para, textStyle);
                paragraph.setWordWrapWidth(this.obWidth - 2 * this.config.padding, true);
                this.paragraphs.push(paragraph);
                verticalSpacing += paragraph.height + paragraphSpacing;
                this.setSize(Math.max(this.obWidth, paragraph.width), verticalSpacing);
            });
        });

        // Back button
        this.backButton = PhaserButton.createQuickBackButton(this.scene, this.config.padding + textStyle.padding, 0);
        this.backButton.setName("back");
        this.backButton.tabIndex = 1;
        this.backButton.on('buttonClicked', () => {
            this.config.onBack();
        });

        // Next Button
        this.startGameButton = new PhaserButton(this.scene, 0, 0, 300, 100, TranslateApi.translate("common.startGame"), PhaserButtonConfig.NextButtonConfig);
        this.startGameButton.tabIndex = 1;
        this.setSize(this.width, this.height + this.startGameButton.displayHeight + 2 * this.config.padding);

        this.startGameButton.on('buttonClicked', () => {
            this.config.onStartGame();
        });

        this.startGameButton.setY(this.displayHeight - this.startGameButton.displayHeight - this.config.padding);
        if (this.backButton != null) {
            this.backButton.setY(this.displayHeight - this.backButton.displayHeight - this.config.padding);
        }

        // Add text box background
        this.background = this.scene.add.image(0, 0, "pixel");
        this.background.setOrigin(0);
        this.background.setDisplaySize(this.displayWidth, this.displayHeight);
        this.background.setTint(0x000000);
        this.background.setPosition(borderWidth + this.config.padding + textStyle.padding, borderWidth + this.config.padding + textStyle.padding);

        // Add text box border
        this.border = this.scene.add.image(0, 0, "pixel");
        this.border.setOrigin(0);
        this.border.setDisplaySize(this.background.displayWidth + 2 * borderWidth, this.background.displayHeight + 2 * borderWidth);
        this.border.setTint(borderColor);
        this.background.setPosition(borderWidth, borderWidth);

        this.startGameButton.setX(this.border.getBounds().right - this.startGameButton.displayWidth - this.config.padding - textStyle.padding);

        this.add(this.border);
        this.add(this.background);
        this.add(this.paragraphs);
        this.add(this.backButton);
        this.add(this.startGameButton);

        this.setDepth(2);
    }

    createKeyboardInstructionsButton() {
        var config: PhaserButtonConfig = {
            backgroundColor: Color.KUDER_SECONDARY_BUTTON,
            smartSize: true
        };

        // Button to show keyboard instructions
        var keyboardButton = new PhaserButton(this.scene, 0, 0, 300, 50, TranslateApi.translate("public.keyboardInstructions"), config);
        // Hide this textbox show another one with they keyboard instructions
        keyboardButton.on('buttonClicked', () => {
            this.config.onKeyboardInstructions();
        });
    }
}



// WEBPACK FOOTER //
// ./src/games/shared/GameInstructionsTextBox.ts